import getApiClient from '@/plugins/api-client'
import Vue from 'vue'

export default {
  loadCategory () {
    const api = getApiClient(this.$store)
    const categoryId = this.$route.params.id

    api.get(`categories/${categoryId}`)
      .then(result => {
        this.category = result.data
      })
      .catch(error => {
        this.error = error.response
      })
  },

  save () {
    this.errors = {}
    const api = getApiClient(this.$store)
    const method = this.category.slug ? 'patch' : 'post'
    const options = {}

    let endpoint = 'categories'

    if (method === 'patch') {
      options.headers = {
        'Content-Type': 'application/merge-patch+json',
      }
      endpoint = this.category['@id']
    }

    const payload = {
      name: this.category.name,
      description: this.category.description,
    }

    api[method](endpoint, payload, options)
      .then(result => {
        this.user = result.data
        this.$store.commit('app/raiseSuccess', 'Categoria salva com sucesso')
        this.$router.push({
          name: 'BlogCategories',
        })
      })
      .catch(error => {
        if (error.response.status === 422) {
          this.parseErrors(error.response.data)
        }
        this.$store.commit('app/raiseError', 'Falha ao salvar categoria')
      })
  },

  parseErrors (errors) {
    const self = this

    errors.violations.forEach(violation => {
      Vue.set(self.errors, violation.propertyPath, violation.message)
    })
  },
}
